// Shared boards, settings and local-library wording.
export const boardsEn: Record<string, string> = {
  "settings.language": "Language",
  "return.title": "Return to your game",
  "return.help": "Open this link in the original browser, or sign in with the email of the account that owns this invitation or game. Opening the link does not join or start a game.",
  "return.account": "This account cannot open this resource. It may have expired, or belong to another account.",
  "return.switch": "Use another account",
  "return.failed": "Could not check your access. Try again.",
  "common.retry": "Try again",
  "nav.club": "Club",
  "nav.myGames": "My games",
  "settings.sound": "Sound",
  "settings.appearanceGroup": "Appearance",
  "settings.boardGroup": "Board and analysis",
  "settings.accountGroup": "Account",
  "settings.boardSettings": "Board settings",
  "settings.browserScope": "Appearance and board preferences apply in this browser.",
  "settings.guestAccount": "You can play and study without an account. Use email to save and recover web games.",
  "settings.accountFailed": "Account details are unavailable. Browser settings still work. Reload to try again.",
  "settings.clubName": "Your club name (optional)",
  "settings.nameLabel": "Name shown to other players",
  "settings.nameHelp": "3–20 letters, numbers, underscores or hyphens. You can keep the guest name and play immediately.",
  "settings.saveName": "Save name",
  "settings.skip": "Skip",
  "settings.nameSaved": "Name saved.",
  "settings.nameFailed": "Could not save the name. Check the format and try again.",
  "settings.session": "Browser session",
  "settings.signOutHelp": "Signing out removes this browser’s seat access. Email recovers server-saved games; unsaved guest games may become inaccessible. Computer games stay in this browser.",
  "settings.signOutBrowser": "Sign out of this browser",
  "settings.signOutFailed": "Could not sign out. Try again.",
  "computer.leaveConfirm": "Leave this unfinished computer game? It has not been saved.",
  "computer.review": "Review game",
  "computer.savedLocal": "Saved in this browser. Find it in My games.",
  "computer.saveFailed": "This game could not be saved. You can still review, analyze or download it here before leaving.",
  "computer.engineFailed": "The engine is unavailable. The clock is paused. Try again to continue.",
  "analysis.board": "Analysis board",
  "analysis.finishedOnly": "Analysis is available after this game finishes.",
  "analysis.returnGame": "Return to game",
  "analysis.enterLine": "Play moves for either side to explore a line.",
  "analysis.copyLinePgn": "Copy line PGN",
  "analysis.downloadLinePgn": "Download line PGN",
  "analysis.copyGamePgn": "Copy game PGN",
  "analysis.downloadGamePgn": "Download game PGN",
  "analysis.backToGame": "Return to main line",
  "library.computer": "Computer games · This browser",
  "library.localHelp": "Stored only in this browser, up to 24 finished games. Signing in does not upload or recover them.",
  "library.noComputer": "No finished computer games in this browser yet.",
  "library.webGames": "Web games",
  "library.saveGames": "Save or recover web games",
  "library.saveHelp": "Use email to save web games and recover them in another browser. Your opponent can stay a guest. Computer games and studies stay in this browser.",
  "library.recoverHelp": "Your email recovers web games saved to your library.",
  "library.saveEach": "Use Save game beside a web game in My games.",
  "library.saveThis": "Save this game",
  "library.saved": "Saved to My games.",
  "library.savedRecover": "Web games saved. Your email can recover them in another browser.",
  "library.emailDisabled": "Email sign-in is currently unavailable. You can keep playing in this browser.",
  "library.emailFailed": "Could not check email access. Reload to try again.",
  "library.signedIn": "Signed in as {name}.",
  "library.guest": "Playing as a guest. Keep this browser’s cookies to return to your web games.",
  "library.noSession": "Use email to recover saved web games. A new guest game needs no account.",
  "library.empty": "No web games yet.",
  "library.more": "More games",
  "library.temporaryUntil": "Temporary · available until {date}",
  "library.retained": "Retained by a participant; not yet saved to your library",
  "library.temporary": "Temporary · unsaved games end after seven days without a move or resume",
  "library.saveGame": "Save game",
  "library.failed": "Web games are unavailable. Your local games are still shown below. Try again.",
  "library.saveFailed": "Could not save this game. Try again.",
  "library.waiting": "Waiting",
  "library.active": "In progress",
  "library.paused": "Paused",
  "library.finished": "Finished",
  "library.returned": "Continues in Messages",
  "telegram.title": "Notifications",
  "telegram.intro": "Get game notifications in Telegram. Connecting enables these alerts.",
  "telegram.connected": "Telegram connected",
  "telegram.connect": "Connect Telegram",
  "telegram.disconnect": "Disconnect",
  "telegram.disconnected": "Telegram disconnected.",
  "telegram.alerts": "Telegram notifications",
  "telegram.unavailable": "Telegram is currently unavailable. Try again later.",
  "telegram.accountRequired": "An email-verified account keeps these notifications connected to your games. Sign in here to connect.",
  "telegram.waiting": "Waiting for Telegram…",
  "telegram.pressStart": "Press Start in the bot chat, then return here. This page checks the connection automatically.",
  "telegram.expired": "This connection link expired. Try again for a new link.",
  "telegram.failed": "Could not complete this request. Check your connection and try again.",
  "telegram.statusFailed": "Could not check Telegram status. Try again when connected.",
  "play.eyebrow": "A small chess club",
  "play.title": "A game with someone.",
  "play.intro": "Invite a friend or meet a player here. Open a board, take your time.",
  "play.invite": "Invite a friend",
  "play.inviteHelp": "A private link, ready to share with any phone or computer.",
  "play.side": "Your side",
  "play.create": "Create invitation",
  "play.find": "Find a player",
  "play.findHelp": "Join the people who are here and ready for a game.",
  "play.prior": "Return to your last invitation",
  "play.openInvitations": "Your open invitations",
  "play.openInvitation": "Open invitation",
  "play.cancelInvitation": "Cancel invitation",
  "play.waitingForFriend": "Waiting for a friend",
  "play.invitationWith": "Invitation with {name}",
  "play.invitationLimit": "You already have three open invitations. Open Play to reuse or cancel one before creating another.",
  "play.invitationLoadFailed": "Could not load your open invitations. Please retry.",
  "play.invitationCancelled": "Invitation cancelled. You can create a new one.",
  "play.retryInvitation": "Retry invitation",
  "waiting.opponentHere": "{name} is waiting for you",
  "waiting.opponentAway": "{name} has left the waiting room",
  "waiting.theyAreBusy": "{name} is busy and would like to play later.",
  "waiting.atInvitation": "At the invitation now.",
  "waiting.awayFromInvitation": "Away from the invitation. It stays open.",
  "waiting.currentGame": "Your current game is still running. You can ask this opponent to wait.",
  "waiting.later": "Later — I’m busy",
  "waiting.replySent": "Busy reply sent",
  "waiting.toldBusy": "Your opponent has been told you’re busy. The invitation stays open.",
  "waiting.connectionUnknown": "Connection lost. Waiting-room status is unavailable until you reconnect.",
  "waiting.statusFor": "Waiting-room status for {name}",
  "play.noAccount": "No account needed to play. Save your web games with an email whenever you choose.",
  "play.preparing": "Preparing your invitation…",
  "play.failed": "Could not connect. Please retry."
};

export const boardsSl: Record<string, string> = {
  "settings.language": "Jezik",
  "return.title": "Vrnitev v partijo",
  "return.help": "Povezavo odprite v prvotnem brskalniku ali se prijavite z e-pošto računa, ki je lastnik povabila ali partije. Odpiranje povezave ne pridruži igralca in ne začne partije.",
  "return.account": "Ta račun ne more odpreti povezave. Morda je potekla ali pripada drugemu računu.",
  "return.switch": "Uporabi drug račun",
  "return.failed": "Dostopa ni bilo mogoče preveriti. Poskusite znova.",
  "common.retry": "Poskusi znova",
  "nav.club": "Klub",
  "nav.myGames": "Moje partije",
  "settings.sound": "Zvok",
  "settings.appearanceGroup": "Videz",
  "settings.boardGroup": "Šahovnica in analiza",
  "settings.accountGroup": "Račun",
  "settings.boardSettings": "Nastavitve šahovnice",
  "settings.browserScope": "Videz in nastavitve šahovnice veljajo v tem brskalniku.",
  "settings.guestAccount": "Igrate in vadite lahko brez računa. Z e-pošto shranite in obnovite spletne partije.",
  "settings.accountFailed": "Podatki računa niso na voljo. Nastavitve brskalnika še vedno delujejo. Poskusite z osvežitvijo.",
  "settings.clubName": "Vaše ime v klubu (neobvezno)",
  "settings.nameLabel": "Ime, ki ga vidijo drugi igralci",
  "settings.nameHelp": "3–20 črk, številk, podčrtajev ali vezajev. Lahko obdržite ime gosta in takoj igrate.",
  "settings.saveName": "Shrani ime",
  "settings.skip": "Preskoči",
  "settings.nameSaved": "Ime je shranjeno.",
  "settings.nameFailed": "Imena ni bilo mogoče shraniti. Preverite obliko in poskusite znova.",
  "settings.session": "Seja brskalnika",
  "settings.signOutHelp": "Odjava odstrani dostop tega brskalnika do igralnih mest. E-pošta obnovi partije, shranjene na strežniku; neshranjene gostujoče partije lahko postanejo nedostopne. Partije z računalnikom ostanejo v tem brskalniku.",
  "settings.signOutBrowser": "Odjavi ta brskalnik",
  "settings.signOutFailed": "Odjava ni uspela. Poskusite znova.",
  "computer.leaveConfirm": "Zapustim nedokončano partijo z računalnikom? Ni bila shranjena.",
  "computer.review": "Preglej partijo",
  "computer.savedLocal": "Shranjeno v tem brskalniku. Najdete jo med Mojimi partijami.",
  "computer.saveFailed": "Partije ni bilo mogoče shraniti. Preden zapustite stran, jo lahko tukaj pregledate, analizirate ali prenesete.",
  "computer.engineFailed": "Pogon ni na voljo. Ura je ustavljena. Za nadaljevanje poskusite znova.",
  "analysis.board": "Analizna šahovnica",
  "analysis.finishedOnly": "Analiza je na voljo po koncu te partije.",
  "analysis.returnGame": "Vrni se v partijo",
  "analysis.enterLine": "Za raziskovanje različice igrajte poteze obeh strani.",
  "analysis.copyLinePgn": "Kopiraj PGN različice",
  "analysis.downloadLinePgn": "Prenesi PGN različice",
  "analysis.copyGamePgn": "Kopiraj PGN partije",
  "analysis.downloadGamePgn": "Prenesi PGN partije",
  "analysis.backToGame": "Vrni se na glavno različico",
  "library.computer": "Partije z računalnikom · Ta brskalnik",
  "library.localHelp": "Samo v tem brskalniku, do 24 končanih partij. Prijava jih ne naloži na strežnik in jih ne obnovi.",
  "library.noComputer": "V tem brskalniku še ni končanih partij z računalnikom.",
  "library.webGames": "Spletne partije",
  "library.saveGames": "Shrani ali obnovi spletne partije",
  "library.saveHelp": "Z e-pošto shranite spletne partije in jih obnovite v drugem brskalniku. Nasprotnik lahko ostane gost. Partije z računalnikom in študije ostanejo v tem brskalniku.",
  "library.recoverHelp": "Z e-pošto obnovite spletne partije, shranjene v vaši knjižnici.",
  "library.saveEach": "Izberite Shrani partijo ob spletni partiji med Mojimi partijami.",
  "library.saveThis": "Shrani to partijo",
  "library.saved": "Shranjeno med Moje partije.",
  "library.savedRecover": "Spletne partije so shranjene. Z e-pošto jih lahko obnovite v drugem brskalniku.",
  "library.emailDisabled": "Prijava z e-pošto trenutno ni na voljo. V tem brskalniku lahko še naprej igrate.",
  "library.emailFailed": "Dostopa z e-pošto ni bilo mogoče preveriti. Poskusite z osvežitvijo.",
  "library.signedIn": "Prijavljeni kot {name}.",
  "library.guest": "Igrate kot gost. Ohranite piškotke tega brskalnika za vrnitev v spletne partije.",
  "library.noSession": "Z e-pošto obnovite shranjene spletne partije. Za novo gostujočo partijo ne potrebujete računa.",
  "library.empty": "Še ni spletnih partij.",
  "library.more": "Več partij",
  "library.temporaryUntil": "Začasna · na voljo do {date}",
  "library.retained": "Shranjena pri udeležencu; še ni v vaši knjižnici",
  "library.temporary": "Začasna · neshranjene partije se končajo po sedmih dneh brez poteze ali nadaljevanja",
  "library.saveGame": "Shrani partijo",
  "library.failed": "Spletne partije niso na voljo. Lokalne partije so še vedno prikazane spodaj. Poskusite znova.",
  "library.saveFailed": "Partije ni bilo mogoče shraniti. Poskusite znova.",
  "library.waiting": "Čakanje",
  "library.active": "V teku",
  "library.paused": "Prekinjena",
  "library.finished": "Končana",
  "library.returned": "Se nadaljuje v Sporočilih",
  "telegram.title": "Obvestila",
  "telegram.intro": "Prejemajte obvestila o partijah v Telegramu. Povezava omogoči ta obvestila.",
  "telegram.connected": "Telegram je povezan",
  "telegram.connect": "Poveži Telegram",
  "telegram.disconnect": "Odklopi",
  "telegram.disconnected": "Telegram je odklopljen.",
  "telegram.alerts": "Obvestila v Telegramu",
  "telegram.unavailable": "Telegram trenutno ni na voljo. Poskusite pozneje.",
  "telegram.accountRequired": "Račun s potrjeno e-pošto poveže ta obvestila z vašimi partijami. Za povezavo se prijavite tukaj.",
  "telegram.waiting": "Čakanje na Telegram…",
  "telegram.pressStart": "V pogovoru z botom pritisnite Start, nato se vrnite sem. Ta stran samodejno preveri povezavo.",
  "telegram.expired": "Povezava je potekla. Poskusite znova za novo povezavo.",
  "telegram.failed": "Zahteve ni bilo mogoče dokončati. Preverite povezavo in poskusite znova.",
  "telegram.statusFailed": "Stanja Telegrama ni bilo mogoče preveriti. Poskusite znova, ko ste povezani.",
  "play.eyebrow": "Majhen šahovski klub",
  "play.title": "Partija v dobri družbi.",
  "play.intro": "Povabite prijatelja ali tukaj poiščite soigralca. Odprite šahovnico in si vzemite čas.",
  "play.invite": "Povabi prijatelja",
  "play.inviteHelp": "Zasebna povezava, ki jo lahko delite s telefonom ali računalnikom.",
  "play.side": "Vaša stran",
  "play.create": "Ustvari povabilo",
  "play.find": "Poišči igralca",
  "play.findHelp": "Pridružite se igralcem, ki so tukaj in pripravljeni na partijo.",
  "play.prior": "Vrni se na zadnje povabilo",
  "play.openInvitations": "Vaša odprta povabila",
  "play.openInvitation": "Odpri povabilo",
  "play.cancelInvitation": "Prekliči povabilo",
  "play.waitingForFriend": "Čakanje na prijatelja",
  "play.invitationWith": "Povabilo z igralcem {name}",
  "play.invitationLimit": "Imate že tri odprta povabila. Na strani Igraj odprite ali prekličite eno, preden ustvarite novo.",
  "play.invitationLoadFailed": "Odprtih povabil ni bilo mogoče naložiti. Poskusite znova.",
  "play.invitationCancelled": "Povabilo je preklicano. Ustvarite lahko novo.",
  "play.retryInvitation": "Poskusi znova ustvariti povabilo",
  "waiting.opponentHere": "{name} vas čaka",
  "waiting.opponentAway": "{name} je zapustil čakalnico",
  "waiting.theyAreBusy": "{name} je zaseden in želi igrati pozneje.",
  "waiting.atInvitation": "Trenutno je pri povabilu.",
  "waiting.awayFromInvitation": "Trenutno ni pri povabilu. Povabilo ostaja odprto.",
  "waiting.currentGame": "Vaša trenutna partija še poteka. Tega soigralca lahko prosite, naj počaka.",
  "waiting.later": "Pozneje — zaseden sem",
  "waiting.replySent": "Odgovor je poslan",
  "waiting.toldBusy": "Soigralec je obveščen, da ste zasedeni. Povabilo ostaja odprto.",
  "waiting.connectionUnknown": "Povezava je prekinjena. Stanje čakalnice bo na voljo po ponovni povezavi.",
  "waiting.statusFor": "Stanje čakalnice za igralca {name}",
  "play.noAccount": "Za igranje ne potrebujete računa. Spletne partije lahko kadarkoli shranite z e-pošto.",
  "play.preparing": "Pripravljamo vaše povabilo…",
  "play.failed": "Povezava ni uspela. Poskusite znova."
};
